import React from 'react'
import { TextInput } from '@/components/atoms'
import styles from '../RewardSetup.module.scss'
import { preventInvalidNumericInput } from '../../../../utils/inputValidations'

/**
 * PointsCondition component displays the points-based reward condition UI
 * Handles points input for POINTS and CASHBACK reward types
 * 
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing points value
 * @param {Function} props.handlePointsChange - Handler for points input changes
 * @param {string} props.pointsError - Error message for points validation
 * @returns {JSX.Element} The rendered PointsCondition component
 */
const PointsCondition = ({
  formData,
  handlePointsChange,
  pointsError,
}) => {
  return (
    <div className="flex flex-wrap gap-[13px]">
      <span className="text-sm whitespace-nowrap mt-2">by redeeming</span>
      <div className={`w-32 ${styles.rewardSetup__inputPoints}`}>
        <TextInput
          className='placeholder:text-sm text-sm'
          value={formData.points}
          onChange={handlePointsChange}
          label=""
          placeholderText="Points"
          error={pointsError}
          isDark={true}
          type="number"
          id="reward-points"
          handleKeyDown={preventInvalidNumericInput}
        />
      </div>
      <span className="text-sm whitespace-nowrap mt-2">points.</span>
    </div>
  )
}

export default PointsCondition
